import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "8",
  viewBox: "0 0 9 8",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.00766 7.28658C4.81294 7.57191 4.32755 7.57095 4.13396 7.28485L0.649348 2.13507C0.455759 1.84897 0.699161 1.49231 1.08747 1.49308L8.07709 1.50694C8.4654 1.50771 8.70739 1.86534 8.51266 2.15067L5.00766 7.28658Z",
  fill: "#327AE7"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }